<template>
    <div class="payment">
        <div class="alert alert-danger" v-if="error">{{ error }}</div>
        <div class="form-row">
            <div class="col">
                <v-form-field label="Card Number" ref="cardNumber" tag="div" />
            </div>
        </div>
        <div class="form-row mt-3">
            <div class="col col-4">
                <v-form-field label="Exp" ref="cardExpiry" tag="div" />
            </div>
            <div class="col col-4">
                <v-form-field label="CVC" ref="cardCvc" tag="div" />
            </div>
            <div class="col col-4">
                <v-form-field
                    label="Zip Code"
                    ref="cardZip"
                    v-model="zip"
                    maxlength="5"
                />
            </div>
        </div>

        <template v-if="!noFooter">
            <div class="text-right">
                <v-button
                    :disabled="disabled"
                    @click.prevent="save"
                    class="ml-auto mt-3"
                    >{{ buttonText }}</v-button
                >
            </div>
        </template>
    </div>
</template>

<script>
import VFormField from "@/components/ui/VFormField";

export default {
    name: "VStripeTokenForm",
    components: {
        VFormField
    },
    props: {
        buttonText: { default: "Save" },
        noFooter: { type: Boolean }
    },

    data() {
        return {
            card: null,
            zip: null,
            stripe: null,
            elements: [],
            error: null
        };
    },
    mounted() {
        /**
         * Check if stripe is already loaded, if not inject it
         */
        if (window.Stripe) {
            this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_CLIENT_ID);
            this.setupElements();
        } else {
            let tag = document.createElement("script");
            tag.setAttribute("src", "https://js.stripe.com/v3/");
            tag.setAttribute("id", "stripe-loader");
            tag.onload = () => {
                this.stripe = window.Stripe(
                    process.env.VUE_APP_STRIPE_CLIENT_ID
                );
                this.setupElements();
            };
            document.head.appendChild(tag);
        }
    },
    methods: {
        setupElements() {
            // Setup the base stripe elements, this is where you pass the custom font in
            let elements = this.stripe.elements({
                fonts: [
                    {
                        cssSrc:
                            "https://fonts.googleapis.com/css?family=Karla:400,700&display=swap"
                    }
                ]
            });

            // Stripe elements can be styled using a style object
            // https://stripe.com/docs/stripe-js
            let style = {
                    base: {
                        fontSize: "16px",
                        color: "#1e1b1d",
                        fontFamily: "Karla",
                        fontWeight: 400,

                        "::placeholder": {
                            color: "#6c757d"
                        },
                        ":-webkit-autofill": {
                            color: "#6c757d"
                        }
                    }
                },
                // And state based custom class names
                classes = {
                    focus: "focus",
                    empty: "empty",
                    invalid: "invalid"
                };

            // These are the only required fields
            let fields = ["cardNumber", "cardExpiry", "cardCvc"];

            // Create each Stripe element
            fields.forEach(field => {
                let element = elements.create(field, { style, classes }),
                    input = this.$refs[field].$refs.input;
                element.mount(input);

                element.addEventListener("blur", () => {
                    // When the stripe element is blurred, tell our form field to remove focused styling
                    if (input.classList.contains("empty")) {
                        this.$refs[field].focused = false;
                    }
                });

                element.addEventListener("focus", () => {
                    // Force our focused styles when stripe element is focused
                    this.$refs[field].focused = true;
                });

                this.elements.push(element);
            });
        },
        async save() {
            // Create the stripe token, only requires to pass one of the elements.
            // Also pass in the zip code data
            const { token, error } = await this.stripe.createToken(
                this.elements[0],
                { address_zip: this.zip }
            );

            if (error) {
                this.$emit("error", error);
                this.error = error.message;
                return Promise.reject(error);
            } else {
                this.$emit("success", token);
                return Promise.resolve(token);
            }
        }
    }
};
</script>

<style>
.payment .input.StripeElement {
    opacity: 0;
    transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    will-change: opacity;
}
.payment .input.focus,
.payment .input:not(.empty) {
    opacity: 1;
}
</style>
